import React from "react";
import type { ModeRendererProps } from "./types";

export function VasarelyFlamingoMode({ Copy }: ModeRendererProps) {
  return (
    <g>
      <rect width={794} height={1123} fill="#fff6fb" />
      <ellipse cx={520} cy={680} rx={260} ry={140} fill="#ffd1e8" transform="rotate(-18 520 680)" />
      <path d="M360 760 C420 700, 520 700, 560 760 L540 780 C500 740, 420 740, 360 780 Z" fill="#ff6f9c" />
      <g className="mode-copy" transform="translate(48,840)" fill="#2b1030"><text x={0} y={0} fontSize={18}>{Copy?.title}</text></g>
    </g>
  );
}

export default VasarelyFlamingoMode;
